import axios from 'axios';
import {API_BASE_URL} from 'constants/app';
import {TokenRepository} from 'domain/ports/TokenRepository';
import {TokenValidationResponse} from 'domain/types/tokenTypes';

export class HttpTokenRepository implements TokenRepository {
    async validateToken(token: string): Promise<TokenValidationResponse> {
        try {
            const response = await axios.get<TokenValidationResponse>(
                `${API_BASE_URL}/api/v1/tokens/validate`,
                {
                    params: {accessToken: token}
                }
            );

            return response.data;
        } catch (error: unknown) {
            console.error('Error al validar token:', error);

            return {
                tokenValid: false,
                tokenStatus: 'INVALID',
                message: 'Error de red',
            };
        }
    }
}
